import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { IndexedDbService } from '../../../../core/services/indexed-db.service';
import { CandidatosApiService } from '../../../../core/services/candidatos-api.service';

@Component({
  selector: 'app-validacion-email',
  standalone: false,
  templateUrl: './validacion-email.component.html',
  styleUrl: './validacion-email.component.scss'
})
export class ValidacionEmailComponent {
  @Output() mensajeCodigoActivacion = new EventEmitter<string>();
  @Output() codigoActivacion = new EventEmitter<string>();
  codigoForm: FormGroup;
  validacionError: boolean = false;
  registroInformacion: any = {};
  campos = Array(6).fill(0); // Para generar 6 campos dinámicamente
  mensaje: string = '';
  email: string = ''; // Email para validación

  @ViewChild('codigo1') codigo1Ref: ElementRef<HTMLInputElement> | null = null;
  @ViewChild('codigo2') codigo2Ref: ElementRef<HTMLInputElement> | null = null;
  @ViewChild('codigo3') codigo3Ref: ElementRef<HTMLInputElement> | null = null;
  @ViewChild('codigo4') codigo4Ref: ElementRef<HTMLInputElement> | null = null;
  @ViewChild('codigo5') codigo5Ref: ElementRef<HTMLInputElement> | null = null;
  @ViewChild('codigo6') codigo6Ref: ElementRef<HTMLInputElement> | null = null;

  constructor(private fb: FormBuilder, 
    private router: Router,
    private route: ActivatedRoute,
    private candidatosApiService: CandidatosApiService,
    private indexedDbService: IndexedDbService,) {
    this.codigoForm = this.fb.group({
      codigo1: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      codigo2: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      codigo3: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      codigo4: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      codigo5: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      codigo6: ['', [Validators.required, Validators.pattern('^[0-9]$')]]
    });
  }

  async ngOnInit() {
    // Intentar obtener el email del query parameter primero
    this.route.queryParams.subscribe(params => {
      if (params['email']) {
        this.email = params['email'];
        console.log('📧 Email obtenido de query params:', this.email);
      }
    });

    // Si no hay email en query params, intentar obtenerlo de IndexedDB (flujo antiguo)
    if (!this.email) {
      this.registroInformacion = await this.indexedDbService.obtenerUsuario('1');
      console.log("registroInformacion", this.registroInformacion);
      
      // Intentar obtener email de registroInformacion si existe
      if (this.registroInformacion?.medios_contacto?.email) {
        this.email = this.registroInformacion.medios_contacto.email;
        console.log('📧 Email obtenido de IndexedDB:', this.email);
      }
    }

    // Si aún no hay email, intentar obtenerlo de localStorage (si está disponible)
    if (!this.email) {
      const authUser = localStorage.getItem('authUser');
      if (authUser) {
        try {
          const userData = JSON.parse(authUser);
          if (userData.email) {
            this.email = userData.email;
            console.log('📧 Email obtenido de localStorage:', this.email);
          }
        } catch (e) {
          console.error('Error al parsear authUser:', e);
        }
      }
    }

    if (!this.email) {
      console.warn('⚠️ No se pudo obtener el email. La validación puede fallar.');
    }
  }

  onSubmit(): void {
    if (this.codigoForm.valid) {
      const codigoIngresado = this.codigoForm.value.codigo1 + this.codigoForm.value.codigo2 + this.codigoForm.value.codigo3 + 
                              this.codigoForm.value.codigo4 + this.codigoForm.value.codigo5 + this.codigoForm.value.codigo6;

      // Obtener email de múltiples fuentes posibles
      let _email = this.email;
      
      // Si no hay email en la propiedad del componente, intentar obtenerlo de registroInformacion
      if (!_email && this.registroInformacion?.medios_contacto) {
        if (this.registroInformacion.medios_contacto.email) {
          _email = this.registroInformacion.medios_contacto.email;
        } else if (Array.isArray(this.registroInformacion.medios_contacto)) {
          const emailContacto = this.registroInformacion.medios_contacto.find((v:any) => v.tipo === 'email');
          if (emailContacto) {
            _email = emailContacto.valor || emailContacto.email;
          }
        }
      }

      // Validar que tenemos un email
      if (!_email) {
        console.error('❌ No se pudo obtener el email para validar el código');
        this.validacionError = true;
        this.mensaje = 'Error: No se pudo obtener el correo electrónico. Por favor, intenta nuevamente.';
        return;
      }

      console.log('📧 Validando código para email:', _email);

      this.candidatosApiService.postValidacionCodigoSeguridad(_email, codigoIngresado).subscribe(
        (data: any) => {
          if (data.status === 'success') {

            // Registro de candidato
            this.candidatosApiService.postRegistorContacto(this.registroInformacion).subscribe(
              (data: []) => {
                let _response: any = data;
                this.mensajeCodigoActivacion.emit(_response.mensaje);
                this.codigoActivacion.emit(_response.codigo);
              },(error: {}) => {
                console.error(error);
              }
            );
          } else {
            this.validacionError = true;
            this.mensaje = "error";
            this.mensajeCodigoActivacion.emit(this.mensaje);
          }
        },(error: {}) => {
          console.error(error);
          this.validacionError = true;
          this.mensajeCodigoActivacion.emit("error");
        }
      );
    }
      
  }

  onInputChange(event: any, controlName: string): void {
    const value = event.target.value;

    if (value.length === 1) {
      const nextControl = this.getNextControl(controlName);
      if (nextControl) {
        nextControl.focus();
      }
    }
  }

  getNextControl(currentControlName: string) {
    const controlRefs: { [key: string]: ElementRef<HTMLInputElement> | null } = {
      'codigo1': this.codigo2Ref,
      'codigo2': this.codigo3Ref,
      'codigo3': this.codigo4Ref,
      'codigo4': this.codigo5Ref,
      'codigo5': this.codigo6Ref,
      'codigo6': null,
    };

    return controlRefs[currentControlName]?.nativeElement;
  }

  onInput(event: any, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (value && /^[a-zA-Z0-9]$/.test(value) && index < this.campos.length - 1) {
      const nextInput = document.getElementById('codigo' + (index + 2)) as HTMLElement;
      nextInput?.focus();
    }
  }

  onKeyDown(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace' && !input.value && index > 0) {
      const prevInput = document.getElementById('codigo' + index) as HTMLElement;
      prevInput?.focus();
    }
  }

}
